var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStopped = function SvgStopped(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Stopped_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#F86919"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Stopped_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14161A",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.602 6.6a1 1 0 0 1 1-1h2.8a1 1 0 0 1 1 1v2.8a1 1 0 0 1-1 1h-2.8a1 1 0 0 1-1-1V6.6Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export { SvgStopped as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxtYXNrIGlkPSJtYXNrMF8yOTY4XzYyNTQ5IiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiPgogICAgICAgIDxjaXJjbGUgY3g9IjgiIGN5PSI4IiByPSI4IiBmaWxsPSIjRjg2OTE5Ii8+CiAgICA8L21hc2s+CiAgICA8ZyBtYXNrPSJ1cmwoI21hc2swXzI5NjhfNjI1NDkpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMxNDE2MUEiLz4KICAgICAgICA8cGF0aCBkPSJNNS42MDE1NiA2LjU5OTk3QzUuNjAxNTYgNi4wNDc2OSA2LjA0OTI4IDUuNTk5OTggNi42MDE1NiA1LjU5OTk4SDkuNDAxNTZDOS45NTM4NSA1LjU5OTk4IDEwLjQwMTYgNi4wNDc2OSAxMC40MDE2IDYuNTk5OThWOS4zOTk5OEMxMC40MDE2IDkuOTUyMjYgOS45NTM4NSAxMC40IDkuNDAxNTYgMTAuNEg2LjYwMTU2QzYuMDQ5MjggMTAuNCA1LjYwMTU2IDkuOTUyMjYgNS42MDE1NiA5LjM5OTk4VjYuNTk5OTdaIgogICAgICAgICAgICAgIGZpbGw9IndoaXRlIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";